import React, {Fragment} from 'react';

import { Container } from 'react-bulma-components';
import { ReactComponent as Logo } from '../assets/spinner.svg';
import { keyframes } from '@emotion/core';
import { size } from 'polished';
import styled from '@emotion/styled';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;
const fadein = keyframes`
    0%{opacity:0}
    100%{opacity:1}
`;

const Loader = ({theSize, delay, text, mt}) =>
{
  if(theSize==null)
  {
    theSize = 64;
  }
  if(delay==null)
  {
    delay = 1;
  }
  if(mt==null)
  {
    mt = 20;
  }
  let Spinner = styled(Logo)(size(theSize), {
    display: 'block',
    opacity: 0,
    margin: 'auto',
    fill: '#d8d9e0',
    animation: `${fadein} 500ms ease forwards`,
    animationDelay: `${delay}s`,
    '& #spinner': {
      transformOrigin: 'center',
      animation: `${spin} 1s linear infinite`,
    },
  });
  return(
    <Fragment>
    <Container style={{marginTop: `${mt}px`}} >
    <Spinner/>
    {text && <div style={{textAlign: 'center'}}>{text}</div>}
    </Container>
    </Fragment>
  )
}
export default Loader;